import Http from "../../../core/http-axios-react/http/Http";
import { HttpBaseResponse, HttpData } from "../../../core/HttpResponse";
import { FormGrouping } from "../form/InsertGrouping";
import { FormGroupingHistory } from "../form/InsertHistoryGrouping";
import { IGroupingDetail, IGroupingHistory } from "./ProdukDetail.type";

export const getGroupingDetails = async ({
  product_id,
  page,
  perPage,
}: {
  product_id?: number;
  page: number;
  perPage: number;
}) => {
  const res = await Http.get<HttpBaseResponse<HttpData<IGroupingDetail[]>>>({
    url: `/product/grouping-products`,
    params: {
      product_id,
      page,
      per_page: perPage,
    },
  });
  return res;
};

export const getGroupingDetail = async ({ id }: { id?: number }) => {
  const res = await Http.get<HttpBaseResponse<IGroupingDetail>>({
    url: `/product/grouping-products/${id}`,
  });
  return res;
};

export const addGrouping = async ({
  current_stock,
  initial_stock,
  product_id,
  status,
  group_name,
}: FormGrouping) => {
  const res = await Http.post({
    url: "/product/grouping-products",
    data: {
      group_name,
      current_stock,
      initial_stock,
      product_id,
      status,
    },
  });
  return res;
};

export const addGroupingHistory = async ({
  grouping_product_id,
  notes,
  quantity,
  status,
}: FormGroupingHistory) => {
  const res = await Http.post({
    url: "/product/grouping-product-stock-histories",
    data: {
      grouping_product_id,
      notes,
      quantity,
      status,
    },
  });
  return res;
};

export const updateGrouping = async ({
  id,
  status,
  current_stock,
  group_name,
}: Omit<FormGrouping, "initial_stock" | "product_id"> & {
  id: number;
}) => {
  const res = await Http.put({
    url: `/product/grouping-products/${id}`,
    useFormMultiPart: false,
    data: {
      group_name,
      status,
      current_stock,
    },
  });
  return res;
};

export const deleteGrouping = async ({ id }: { id: number }) => {
  const res = await Http.delete({
    url: `/product/grouping-products/${id}`,
    useFormMultiPart: false,
  });
  return res;
};

export const updateGroupingHistory = async ({
  id,
  notes,
  quantity,
}: Omit<FormGroupingHistory, "grouping_product_id"> & { id: number }) => {
  const res = await Http.put({
    url: `/product/grouping-product-stock-histories/${id}`,
    useFormMultiPart: false,
    data: {
      notes,
      quantity,
    },
  });
  return res;
};

export const deleteGroupingHistory = async ({ id }: { id: number }) => {
  const res = await Http.delete({
    url: `/product/grouping-product-stock-histories/${id}`,
    useFormMultiPart: false,
  });
  return res;
};

export const getGroupingHistoryDetail = async ({
  grouping_product_id,
  perPage,
  per_page,
  page,
}: {
  grouping_product_id?: number;
  perPage?: number;
  per_page?: number;
  page?: number;
}) => {
  const res = await Http.get<HttpBaseResponse<HttpData<IGroupingHistory[]>>>({
    url: "/product/grouping-product-stock-histories",
    params: {
      grouping_product_id,
      perPage,
      per_page,
      page,
    },
  });
  return res;
};

export const importFromFile = async ({ file }: { file: File }) => {
  const result = await Http.post({
    url: "/product/grouping-products/import",
    data: {
      file,
    },
  });
  return result;
};

export const exportFromFile = async () => {
  const result = await Http.get({
    url: "/product/grouping-products/export",
  });
  return result;
};
